import React, { FC, PropsWithChildren, createContext, useCallback, useState } from 'react';

import Snackbar from './index';

export const SnackbarContext = createContext<(message: string) => void>(() => undefined);

export const SnackbarManager: FC<PropsWithChildren<{ initialMessage?: string }>> = ({ children, initialMessage }) => {
  const [message, setMessageState] = useState<string | undefined>(initialMessage);
  const [timestamp, setTimestamp] = useState<number | undefined>(undefined);
  const setMessage = useCallback((newMessage: string) => {
    setMessageState(newMessage);
    setTimestamp(Date.now());
  }, []);

  return (
    <SnackbarContext.Provider value={setMessage}>
      {children}
      {message && <Snackbar key={timestamp} message={message} />}
    </SnackbarContext.Provider>
  );
};

export default SnackbarManager;
